import React, { Component } from "react";
import { connect } from "react-redux";
// import dayjs from "dayjs";
import { Card, Tag, Button, DatePicker, Divider, message } from "antd";
import {
  req_page_afs_timesetup_log,
  req_single_afs_timesetup,
  req_edit_afs_timesetup,
} from "../../api";
import { usrRole } from "../../utils/dataUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { formateDateDbT } from "../../utils/dateUtil";

const { RangePicker } = DatePicker;
class StatusTimeSetup extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    startTime: "",
    endTime: "",
    domnloadFile: "",
    isShowModal: false,
    handleSetStatus: "NA",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_single_item(1);
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_item = async (current) => {
    const { token } = this.props.user;

    this.setState({ loading: true });
    const result = await req_single_afs_timesetup("", token);
    this.setState({ loading: false });
    const item = result;
    // console.log(item);
    item.StartTime = formateDateDbT(result.StartTime);
    item.EndTime = formateDateDbT(result.EndTime);
    this.setState({ item, handleSetStatus: result.HandleSetStatus });
    this.api_page_items(current);
  };

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    this.setState({ loading: true });
    const result = await req_page_afs_timesetup_log(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_edit_afs_timesetup(item, token);
    this.setState({ loading: false });
    if (result.status === "success") {
      message.success("更新成功");
      this.api_single_item(1);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "欄位",
        dataIndex: "field",
        width: 100,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_time_setup = (times) => {
    const startTime = times[0];
    const endTime = times[1];
    if (startTime) {
      //console.log("start: ", startTime.format("YYYY-MM-DD HH:mm"));
      this.setState({ startTime: startTime.format("YYYY-MM-DD HH:mm") });
    }
    if (endTime) {
      //console.log("end: ", endTime.format("YYYY-MM-DD HH:mm"));
      this.setState({ endTime: endTime.format("YYYY-MM-DD HH:mm") });
    }
  };

  handle_save = () => {
    console.log("save");
    const { userCode } = this.props.user;
    const row = this.state.item;
    row.StartTime = this.state.startTime;
    row.EndTime = this.state.endTime;
    row.StatusChangeOperatorId = userCode;
    row.condition = "BASE";
    this.api_edit_item(row);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_single_item(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      default:
    }
  };

  handle_manual_setting = () => {
    const { HandleSetStatus } = this.state.item;
    const { userCode } = this.props.user;
    const setValue = HandleSetStatus === "ON" ? "OFF" : "ON";
    const row = {
      condition: "STATUS",
      StatusChangeOperatorId: userCode,
      NowStatus: setValue,
      Uid: this.state.item.Uid,
    };
    this.api_edit_item(row);
    this.setState({ HandleSetStatus: setValue });
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { NowStatus, HandleSetStatus, StartTime, EndTime } = this.state.item;
    const title = (
      <>
        <span>設定時間：</span>
        <RangePicker
          showTime={{
            format: "HH:mm",
          }}
          format="YYYY-MM-DD HH:mm"
          onOk={this.handle_time_setup}
        />
        <Button type="primary" onClick={() => this.handle_save()}>
          <i className="fa fa-bars" style={{ marginRight: "4px" }}></i> 設定
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>
      </>
    );
    return (
      <Card title={title}>
        <div style={{ fontSize: "1.2em", fontWeight: "bold" }}>
          <span>開放時間區間：</span>
          <Tag
            color={NowStatus === "ON" ? "green" : "default"}
            style={{ fontSize: "1.2em" }}
          >
            {" "}
            {StartTime}{" "}
          </Tag>
          -{" "}
          <Tag
            color={NowStatus === "ON" ? "green" : "default"}
            style={{ fontSize: "1.2em" }}
          >
            {" "}
            {EndTime}
          </Tag>
        </div>
        <div style={{ fontSize: "1.2em", fontWeight: "bold" }}>
          <span>目前狀態：</span>
          <button
            className={
              NowStatus === "ON"
                ? "btn btn-sm btn-outline-success"
                : "btn btn-sm btn-outline-secondary"
            }
            disabled={true}
          >
            {NowStatus === "ON" ? "開放中" : "關閉中"}
          </button>
          <p></p>
        </div>
        <Divider />
        <div>
          <span>手動關閉：</span>
          <button
            className={
              HandleSetStatus === "ON"
                ? "btn btn-sm btn-primary"
                : "btn btn-sm btn-danger"
            }
            onClick={() => this.handle_manual_setting()}
          >
            {HandleSetStatus === "ON" ? "未設定" : "已設定"}
          </button>
        </div>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(StatusTimeSetup);
